import defaultTheme from './defaultTheme';
const infinitiTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#666666', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#666666', background: '#666666' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#666666' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#666666', border: '#666666', background: '#666666' }), field: {
        focus: '#666666',
        label: '#666666',
        icon: '#666666',
    } });
export default infinitiTheme;
